module.exports = __webpack_public_path__ + "img/20.1d66c10f.svg";